const BASE_URL_AUTH =
  process.env.REACT_APP_ENV === "local"
    ? process.env.REACT_APP_AUTH_BACKEND_URL_LOCAL
    : process.env.REACT_APP_ENV === "staging"
    ? process.env.REACT_APP_AUTH_BACKEND_URL_STAGING
    : process.env.REACT_APP_AUTH_BACKEND_URL_PROD;
const BASE_URL_USER =
  process.env.REACT_APP_ENV === "local"
    ? process.env.REACT_APP_USER_BACKEND_URL_LOCAL
    : process.env.REACT_APP_ENV === "staging"
    ? process.env.REACT_APP_USER_BACKEND_URL_STAGING
    : process.env.REACT_APP_USER_BACKEND_URL_PROD;
const BASE_URL_MEDIA =
  process.env.REACT_APP_ENV === "local"
    ? process.env.REACT_APP_MEDIA_BACKEND_URL_LOCAL
    : process.env.REACT_APP_ENV === "staging"
    ? process.env.REACT_APP_MEDIA_BACKEND_URL_STAGING
    : process.env.REACT_APP_MEDIA_BACKEND_URL_PROD;
const BASE_URL_SEARCH =
  process.env.REACT_APP_ENV === "local"
    ? process.env.REACT_APP_SEARCH_BACKEND_URL_LOCAL
    : process.env.REACT_APP_ENV === "staging"
    ? process.env.REACT_APP_SEARCH_BACKEND_URL_STAGING
    : process.env.REACT_APP_SEARCH_BACKEND_URL_PROD;
const BASE_URL_ADMIN =
  process.env.REACT_APP_ENV === "local"
    ? process.env.REACT_APP_ADMIN_BACKEND_URL_LOCAL
    : process.env.REACT_APP_ENV === "staging"
    ? process.env.REACT_APP_ADMIN_BACKEND_URL_STAGING
    : process.env.REACT_APP_ADMIN_BACKEND_URL_PROD;

export {
  BASE_URL_AUTH,
  BASE_URL_USER,
  BASE_URL_ADMIN,
  BASE_URL_MEDIA,
  BASE_URL_SEARCH,
};
